import React from "react";

const AwaitingTable = ({ data }) => {

    // ✅ Get unique departments
    const departments = [
        ...new Set(data.map(item => item.Department))
    ];

    // ✅ Get unique branches
    const branches = [
        ...new Set(data.map(item => item.branch))
    ];

    // ✅ Build pivot rows
    const tableData = branches.map(branch => {
        const row = { branch };

        let rowTotal = 0;

        departments.forEach(dept => {
            const found = data.find(
                item =>
                    item.branch === branch &&
                    item.Department === dept
            );

            const count = found ? Number(found.count) : 0;

            row[dept] = count;
            rowTotal += count;
        });

        row.total = rowTotal;

        return row;
    });

    // ✅ Department totals
    const departmentTotals = {};

    departments.forEach(dept => {
        departmentTotals[dept] = tableData.reduce(
            (sum, row) => sum + row[dept],
            0
        );
    });

    // ✅ Grand total
    const grandTotal = tableData.reduce(
        (sum, row) => sum + row.total,
        0
    );

    return (
        <div>
            <h3>Awaiting Students Table</h3>

            <table
                border="1"
                cellPadding="8"
                style={{
                    borderCollapse: "collapse",
                    width: "100%"
                }}
            >
                <thead>
                    <tr>
                        <th>Branch</th>

                        {departments.map((dept, index) => (
                            <th key={index}>{dept}</th>
                        ))}

                        <th>Total</th>
                    </tr>
                </thead>

                <tbody>

                    {tableData.map((row, index) => (
                        <tr key={index}>
                            <td>{row.branch}</td>

                            {departments.map((dept, i) => (
                                <td key={i}>{row[dept]}</td>
                            ))}

                            <td>
                                <strong>{row.total}</strong>
                            </td>
                        </tr>
                    ))}

                    {/* ✅ Total Row */}
                    <tr>
                        <td>
                            <strong>Total</strong>
                        </td>

                        {departments.map((dept, index) => (
                            <td key={index}>
                                <strong>
                                    {departmentTotals[dept]}
                                </strong>
                            </td>
                        ))}

                        <td>
                            <strong>{grandTotal}</strong>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    );
};

export default AwaitingTable;